import type { FaireProductEntity } from "../../entity_types/product";

export const p_wgeb6s4gzf: FaireProductEntity = {
  token: "p_wgeb6s4gzf",
  type: "product",
  name: "Porcelain Trinket Dish | Sardines",
  brandToken: "b_11db373e",
  brandName: "Idlewild Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/3604f9a69b2cc4c67f764aeca39dde728220a5a28d829d9289b8a0998b7c2648.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6e75f68dac286eccbf56db955128c94e6a0726ff7b91d31330ed3394d6df687d.jpeg",
    "https://cdn.faire.com/fastly/8273792e1b87a04d97a8da26e22f706172307aeb5101be044f6a7846e8462c25.jpeg",
  ],
  priceDollars: 11,
  description:
    "A fan favorite giftable–Our ceramic trinket dishes are the perfect catchall for your nightstand or dresser. White ceramic is adorned with our colorful, hand-painted designs, and we lined the edge in 10k gold for added flair. Perfectly packaged in plastic-free gift boxes, pretty enough to give without wrapping!\n\n• Round Dish: 3.5″\n• Ceramic with 10k Gold Detailing\n• Plastic-Free Gift Box\n• Food-Safe | Hand Wash Only\n\n\n\n\n\nKeywords for SEO:\nTrinket Dish, Dish, Ring Dish, Ceramic, Porcelain, Gold, Idlewild Co., Idlewild, Accessory, Gift, Stocking Stuffer, Jewelry Dish, Jewelry Box, Sardines, Fish, Sea, Food, Portugal, home decor, vintage, display, earring display, displays for retail, gift idea, wedding, ceramics, engagement gift, jewelry displays, necklace display, ring dish, heart dish, heart trinket dish, trinket box, easter, food themed gift, food theme, foodie gift, travel, mahjong, mahjong accessories, dice dish, dice dishes, coastal decor, summer gifts",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:54.359Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
